import React from 'react';

const Modal = ({ isOpen, onClose, children, size = 'medium', showBackButton = false, backAction }) => {
  if (!isOpen) return null;

  let sizeClass = 'max-w-md';
  let paddingClass = 'p-6';
  let textClass = '';

  if (size === 'small') {
    sizeClass = 'max-w-sm';
    paddingClass = 'p-4';
  } else if (size === 'large') {
    sizeClass = 'max-w-3xl';
    paddingClass = 'p-8';
    textClass = 'text-lg font-bold';
  }

  const handleBackClick = () => {
    if (backAction) {
      backAction();
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-60" onClick={onClose}></div>
      <div className={`bg-white ${paddingClass} rounded-lg shadow-2xl z-10 ${sizeClass} w-full ${textClass}`}>
        {children}
        <div className="flex justify-end gap-2 mt-4">
          {showBackButton && (
            <button
              className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              onClick={handleBackClick}
            >
              Go Back
            </button>
          )}
          <button
            className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
